import { render, staticRenderFns } from "./header-h5.vue?vue&type=template&id=f94cfc40&scoped=true"
import script from "./header-h5.vue?vue&type=script&lang=js"
export * from "./header-h5.vue?vue&type=script&lang=js"
import style0 from "./header-h5.vue?vue&type=style&index=0&id=f94cfc40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94cfc40",
  null
  
)

export default component.exports